import { createAction } from '@reduxjs/toolkit';
import { doneOrderActionTypes } from '../../types';

export const setDoneOrdersFilters = createAction(
  doneOrderActionTypes.setFilters
);
